import { render } from "./Items_Catalog.vue?vue&type=template&id=44d7fd23"
import script from "./Items_Catalog.vue?vue&type=script&lang=js"
export * from "./Items_Catalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__